import React, { Component } from 'react'
import "../styles/FrontButton.css";

export default class FrontButton extends Component {
    
    constructor(){
        super();
        this.state = {
            spanWidth:0
        };
        //Binded the elements in order for the class properties to be methods
        this.setHoverEffect = this.setHoverEffect.bind(this);   
        this.changeSection = this.changeSection.bind(this);
    }

    setHoverEffect(value){
        this.setState({spanWidth:value})
    }
    changeSection(section){
        switch(section)
        {
            case("about"):
                this.props.setProjectVis(false);
                this.props.setAboutVis(true);
                this.props.setCreditsVis(false);
                break;
            case("projects"):
                this.props.setProjectVis(true);
                this.props.setAboutVis(false);
                this.props.setCreditsVis(false);
                break;
            case("credits"):
                this.props.setProjectVis(false);
                this.props.setAboutVis(false);
                this.props.setCreditsVis(true);
                break;
            default:
                break;

        }
    }
    render() {
        return (
            <div onClick = {(e) => {this.changeSection(this.props.section)}} 
                className="frontButtonWrapper"
                onMouseOver={(e) => {this.setHoverEffect("100%")}}
                onMouseLeave = {(e) => {this.setHoverEffect("0%")}} >
                
                <span style = {{width:this.state.spanWidth}}></span>
                <a className="frontButton"  href = {this.props.href} >{this.props.text}</a>
            </div>

        )
    }
}
